import React, {useEffect, useMemo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import ColumnChart from "../../charts/ColumnChart";
import BlockChart from "../../BlockChart";

export default function ConsentByOsChart ({data = [], isSuccess, isFetching: isLoading, refetch}) {
  const { t } = useTranslation();
  const formatData = (data) => {
    return {
      categories: data.map((elt) => (t(elt.os))),
      series: [
        {
          name: t('cmp.analytics.metrics.presentationRate'),
          data: data.map((elt) => ( elt.active_devices ? 100 * elt.displayed / elt.active_devices : 0 ) )
        },
        {
          name: t('cmp.analytics.metrics.consentRate'),
          data: data.map((elt) => ( elt.displayed ? 100 * elt.at_least_one_purpose_consented / elt.displayed : 0 ) )
        }
      ]
    }
  }
  const formattedData = useMemo(() => (formatData(data)), [data])

  return (
    <BlockChart title={t("cmp.analytics.consentsByOs")} isLoading={isLoading} isSuccess={isSuccess}>
      <ColumnChart data={formattedData}/>
    </BlockChart>
  )
}
